<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>




            <div class="col-md-6">
                <app-shared-profile [props]="communityData" type="profile" [loading]="loading"></app-shared-profile>
                <app-payout-account></app-payout-account>
            </div>  

            <div class="col-md-3">
                <app-events [showheader]=true></app-events>
            </div>
        </div>
        <div>
            
        </div>
    </div>
</div>